<template>
  <v-card flat>
    <template v-if="alerts">
      <v-alert
        v-for="(alert, index) in alerts"
        :key="`delivery-alert-${index}`"
        :type="alert.type"
        dense
        class="mb-2"
      >
        {{ alert.text }}
      </v-alert>
    </template>

    <template v-if="improvements">
      <v-alert
        v-for="(improvement, index) in improvements"
        :key="`delivery-improvement-${index}`"
        type="info"
        dense
        class="mb-2"
      >
        {{ getImprovementText(improvement) }}
      </v-alert>
    </template>
  </v-card>
</template>

<script>
export default {
  name: 'DeliveryAlert',
  props: {
    /**
     * Alerts need to be shown
     *
     * [
     *  {
     *    type: 'error', // 'error', 'warning', 'info'
     *    text: 'alert text',
     *  }
     * ]
     */
    alerts: Array,
    improvements: Array,
  },
  data() {
    return {
      formatter: new Intl.NumberFormat('nl', {
        style: 'currency',
        currency: 'EUR',
      }),
    };
  },
  methods: {
    getImprovementText(improvement) {
      const part1Text = this.$translate('DELIVERY_IMPROVEMENT_1');
      const part1Value = this.formatter.format(
        improvement.FreeDeliveryOrderValue -
          improvement.FreeDeliveryAdditionalAmountRequired
      );

      const part2Text = this.$translate('DELIVERY_IMPROVEMENT_2');
      const part2Value = this.formatter.format(
        improvement.FreeDeliveryOrderValue
      );

      return `${part1Text}${part1Value} ${part2Text}${part2Value}`;
    },
  },
};
</script>
